import { useAppDispatch, useAppSelector } from '@/lib/hooks/use-redux'
import { closeModal, openModal, selectProduct } from '@/lib/redux'
import React from 'react'

export const useSearch = () => {
  const dispatch = useAppDispatch()

  const { modals } = useAppSelector((state) => state.modals)
  const { product } = useAppSelector((state) => state.selectedProduct)
  const [searchQuery, setSearchQuery] = React.useState<string>('')
  const [isSearched, setIsSearched] = React.useState<boolean>(false)

  return {
    searchQuery,
    setSearchQuery,
    openModal: () => dispatch(openModal('SEARCH')),
    closeModal: () => dispatch(closeModal('SEARCH')),
    isModalOpen: modals.includes('SEARCH'),
    selectProduct: (product: Product) => dispatch(selectProduct(product)),
    selectedProduct: product,
    isSearched,
    setIsSearched,
  }
}
